import type { z } from "zod";
import { supabase } from "../supabase";
import { AppError, toAppError } from "../errors";

/** Call a Postgres function through PostgREST and validate the result shape. */
export async function rpc<S extends z.ZodType>(fn: string, args: Record<string, unknown>, schema: S): Promise<z.infer<S>> {
  let res;
  try {
    res = await supabase.rpc(fn, args);
  } catch (e) {
    throw toAppError(e);
  }
  if (res.error) throw toAppError(res.error);
  const parsed = schema.safeParse(res.data);
  if (!parsed.success) {
    console.error(`Unexpected ${fn} response`, parsed.error.issues);
    throw new AppError("bad_response", fn);
  }
  return parsed.data;
}
